import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import otp from './modules/otp'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    otp
  }
})
